import React from 'react';
import CarouselTemplate from '@redturtle/qubicaamf-theme/components/Blocks/Listing/Carousel/CarouselTemplate.jsx';

const CarouselTemplateSkeleton = (data) => {
  let items = [];
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].forEach((i) => {
    items.push({ '@id': i + '' });
  });
  return (
    <div className="skeleton-template">
      <CarouselTemplate {...data} items={items} />
    </div>
  );
};

export default CarouselTemplateSkeleton;
